module.exports = __webpack_public_path__ + "img/ILEK_80X30.8b983ded.png";